<div *ngIf="loading" class="suggested-loading">
  <nb-spinner size="small" status="primary"></nb-spinner>
</div>
<ng-container *ngIf="!loading">
  <div *ngIf="!matches?.length" class="suggested-empty">
    {{ 'suggestedvacancies.empty' | translate }}
  </div>
  <div *ngIf="matches?.length" class="suggested-grid">
    <div class="vacancy-card"
         *ngFor="let match of visibleMatches"
         (click)="onCardClick(match)">
      <div class="card-header-row">
        <div class="vacancy-title">{{ match.vacancy?.title }}</div>
        <span *ngIf="match.match_demoted; else ring" class="score-dash"
              [nbTooltip]="'eligibility.demoted' | translate">&ndash;</span>
        <ng-template #ring>
          <span class="score-ring" [style.--p]="match.score ?? 0"
                [nbTooltip]="('match score' | translate) + ': ' + (match.score ?? 0).toFixed(0) + '/100'">
            <span>{{ (match.score ?? 0).toFixed(0) }}</span>
          </span>
        </ng-template>
      </div>
      <div class="vacancy-meta">
        <span *ngIf="match.vacancy?.company">{{ match.vacancy.company }}</span>
        <span *ngIf="match.vacancy?.company && match.vacancy?.location"> &middot; </span>
        <span *ngIf="match.vacancy?.location">{{ match.vacancy.location }}</span>
      </div>
      <bst-eligibility-summary *ngIf="match.eligibility?.verdict === 'ineligible'" [eligibility]="match.eligibility" [static]="true"></bst-eligibility-summary>
      <div class="card-divider"></div>
      <ng-container *ngIf="getFactors(match) as factors">
      <div *ngIf="factors.length > 0" class="factors-grid">
        <div class="factor-item"
             *ngFor="let f of factors"
             [nbTooltip]="f.notes" nbTooltipStatus="basic">
          <div class="factor-header">
            <span class="factor-label">{{ f.label }}</span>
            <span class="factor-value">{{ (f.score * 100).toFixed(0) }}%</span>
          </div>
          <div class="factor-bar-track">
            <div class="factor-bar-fill"
                 [class]="'bar-' + getFactorBarColor(f.score)"
                 [style.width.%]="f.score * 100">
            </div>
          </div>
        </div>
      </div>
      </ng-container>
      <div class="vacancy-footer">
        <span class="chip">{{ match.vacancy?.source }}</span>
        <span *ngIf="match.vacancy?.deadline" class="chip">{{ match.vacancy.deadline | date:'mediumDate' }}</span>
      </div>
    </div>
  </div>
  <div *ngIf="hasMore" class="suggested-footer">
    <button nbButton size="small" status="basic" shape="semi-round" (click)="expanded = !expanded">
      <nb-icon [icon]="expanded ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
      {{ (expanded ? 'suggestedvacancies.showless' : 'suggestedvacancies.showmore') | translate }}
    </button>
  </div>
  <aside *ngIf="matches?.length" class="suggested-disclosure" role="note"
         [nbTooltip]="'matching.privacy.text' | translate" nbTooltipStatus="basic">
    <nb-icon icon="shield-outline" aria-hidden="true"></nb-icon>
    <small>{{ 'matching.privacy.title' | translate }}</small>
  </aside>
</ng-container>
